import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-systemMonitoring",
  "use": "icon-systemMonitoring-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-systemMonitoring\"><defs><style></style></defs><path d=\"M960 132.267V755.2H64V132.267h896m64-64H0V819.2h1024V68.267z\" /><path d=\"M885.333 546.133h-211.2l-189.866-179.2-142.934 179.2H138.667V480H307.2l168.533-213.333L701.867 480h183.466zM93.867 889.6H921.6v66.133H93.867z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol